export enum daysEnum {
	LUNDI = 221310000,
	MARDI = 221310001,
	MERCREDI = 221310002,
	JEUDI = 221310003,
	VENDREDI = 221310004
}